<template>
  <Hero id="hero"/>
</template>

<script>
import Hero from "@/views/Home/Hero";
export default {
  name: "HomePage",
  components: { Hero }
}
</script>

<style scoped>

</style>